import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import ConsumerInfo from './ConsumerInfo';

function ActionBar({ profile, children }) {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/search');
    };

    return (
        <Paper
            sx={{
                mb: 1,
                backgroundColor: 'tabHeader.main',
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                paddingLeft={1}
                paddingRight={2}
                paddingY={1.2}
                spacing={1}
            >
                <IconButton onClick={handleBack}>
                    <ArrowBackIcon />
                </IconButton>
                <ConsumerInfo profile={profile} />
                <Box sx={{ flexGrow: 1 }} />
                <Stack direction="row" spacing={1}>
                    {children}
                </Stack>
            </Stack>
        </Paper>
    );
}

export default ActionBar;
